var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Vue, Component, Watch, Mixins, } from 'vue-property-decorator';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import ManageGroupCrudSidesheet from '@/pages/carrier-management/manage-group/ManageGroupCrudSidesheet.vue';
import DeletePromptDialog from '@/components/shared/DeletePromptDialog.vue';
import PromptDialog from '@/components/shared/PromptDialog.vue';
import { TableHeading, } from '@/typings';
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
import { ReferenceDataService } from '@/services/reference-data-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import LayoutMixin from '@/mixins/layout-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import PartialSaveMixin from '@/mixins/partial-save-mixin';
import { CarrierGroupService } from '@/services/carrier-management/carrier-group-service';
import { useStore } from 'vuex-simple';
var EditCarrier = /** @class */ (function (_super) {
    __extends(EditCarrier, _super);
    function EditCarrier() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        _this.validationRules = {};
        _this.loading = false;
        _this.currentStep = 'D';
        _this.toolbarTitle = '';
        _this.searchTermForDesks = '';
        _this.searchVisibleForDesks = false;
        _this.dispatchDeskSideSheet = false;
        _this.initialName = '';
        _this.includeDeleted = false;
        _this.filterSideSheet = false;
        _this.dispatchDeskHeaders = [
            new TableHeading('', 'isDefault', true),
            new TableHeading('Name', 'name'),
            new TableHeading('Claim Email', 'email'),
            new TableHeading('Snapshot Time', 'snapshotTime'),
            new TableHeading('Actions', 'id', false),
        ];
        _this.pagination = {
            descending: true,
            page: 1,
            itemsPerPage: 10,
            sortBy: 'isDefault',
            totalItems: 0,
        };
        _this.selectedDispatchDesk = {};
        _this.deleteDeskDialog = false;
        _this.restoreDeskDialog = false;
        _this.selectedItemCanBeDeleted = false;
        _this.options = {
            snapShotTimes: [],
            carrierGroups: [],
            statuses: [],
            horizonEnabled: [],
        };
        _this.item = _this.carrierService.getDefault();
        _this.carrierGroups = [];
        _this.groupSearchInput = '';
        _this.saving = false;
        _this.savingDispatchDesk = false;
        _this.readonly = false;
        _this.idValidationMessage = 'The ID field must start with the number 4.';
        return _this;
    }
    EditCarrier.prototype.navigateToDispatchDesks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isValid, ableToDelete, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$validator.validate('details.*')];
                    case 1:
                        isValid = _a.sent();
                        if (isValid === false) {
                            return [2 /*return*/];
                        }
                        if (!this.isExistingCarrier) return [3 /*break*/, 4];
                        if (!(this.item.desks[0].status === this.inactiveFlag)) return [3 /*break*/, 3];
                        this.includeDeleted = true;
                        return [4 /*yield*/, this.carrierService.canDeleteCarrier(this.item)];
                    case 2:
                        ableToDelete = _a.sent();
                        if (ableToDelete === false) {
                            this.$validator.errors.add({
                                scope: 'details',
                                field: 'status',
                                // tslint:disable-next-line:max-line-length
                                msg: this.item.name + " has associations with a site and material. You must re-assign these to a new carrier first.",
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        this.currentStep = 'DD';
                        return [3 /*break*/, 7];
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.carrierService.save(this.item)];
                    case 5:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        // set the carrier id
                        this.item.id = response.data.carrierId;
                        // set the name of the dispatch desk
                        this.item.desks[0].name = this.item.name;
                        // check if the status is set to inactive and set the includeDeleted flag
                        if (this.item.desks[0].status === this.inactiveFlag) {
                            this.includeDeleted = true;
                        }
                        // navigate to the next step
                        this.currentStep = 'DD';
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.showSnackbar({
                            text: 'Unable to save Carrier. Please try again later.',
                            color: 'error',
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.toggleSearchVisibility = function () {
        var _this = this;
        this.searchVisibleForDesks = !this.searchVisibleForDesks;
        if (this.searchVisibleForDesks === true) {
            // have to wait until animation occurs, next tick
            this.$nextTick(function () {
                var searchInput = _this.$refs.searchInput;
                searchInput.focus();
            });
        }
    };
    EditCarrier.prototype.openEditSideSheet = function (dispatchDesk) {
        var _this = this;
        this.filterSideSheet = false;
        this.dispatchDeskSideSheet = false;
        // reset validation
        this.$validator.reset({
            scope: 'desk',
        });
        // copy - immutable
        var data = __assign({}, dispatchDesk);
        if (this.dispatchDeskSideSheet) {
            this.selectedDispatchDesk = data;
        }
        else {
            this.dispatchDeskSideSheet = !this.dispatchDeskSideSheet;
            if (this.dispatchDeskSideSheet === true) {
                this.selectedDispatchDesk = data;
            }
        }
        if (this.dispatchDeskSideSheet) {
            // have to wait until animation occurs, next tick
            this.$nextTick(function () {
                var input = _this.$refs
                    .dispatchDeskSideSheetAutofocus;
                input.focus();
            });
        }
    };
    EditCarrier.prototype.toggleFilterSideSheet = function () {
        var _this = this;
        this.dispatchDeskSideSheet = false;
        this.$nextTick(function () {
            _this.filterSideSheet = !_this.filterSideSheet;
        });
    };
    EditCarrier.prototype.openCarrierGroupSideSheet = function () {
        var _this = this;
        this.loading = true;
        this.$nextTick(function () {
            _this.store.managementPage.openCrudSidesheet({
                item: _this.carrierGroupService.getDefault(),
                mode: 'create',
            });
            _this.loading = false;
        });
    };
    EditCarrier.prototype.addCarrierGroup = function (item) {
        this.options.carrierGroups.push(item);
        this.item.groupId = item.id;
    };
    EditCarrier.prototype.openDeskDeleteDialog = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.selectedDispatchDesk = item;
                        _a = this;
                        return [4 /*yield*/, this.carrierService.canDeleteDispatchDesk(item)];
                    case 1:
                        _a.selectedItemCanBeDeleted = _b.sent();
                        this.deleteDeskDialog = true;
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _b.sent();
                        this.deleteDeskDialog = false;
                        this.showSnackbar({
                            text: 'Unable to delete dispatch desk',
                            color: 'error',
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.openRestoreDialog = function (item) {
        this.selectedDispatchDesk = item;
        this.restoreDeskDialog = true;
    };
    EditCarrier.prototype.deleteDesk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, items, item, error_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.carrierService.deleteDispatchDesk(this.selectedDispatchDesk)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            items = __spreadArrays(this.item.desks);
                            item = items.filter(function (desk) { return desk.id === _this.selectedDispatchDesk.id; })[0];
                            item.status = this.inactiveFlag;
                            this.item.desks = items;
                            this.showSnackbar({
                                text: "Deleted " + this.selectedDispatchDesk.name,
                                color: 'success',
                            });
                        }
                        else {
                            throw Error('Unable to delete dispatch desk');
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        this.showSnackbar({ text: 'Unable to delete carrier', color: 'error' });
                        return [3 /*break*/, 4];
                    case 3:
                        this.deleteDeskDialog = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.restoreDesk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, items, item, error_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, this.carrierService.restoreDispatchDesk(this.selectedDispatchDesk)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            items = __spreadArrays(this.item.desks);
                            item = items.filter(function (desk) { return desk.id === _this.selectedDispatchDesk.id; })[0];
                            item.status = this.activeFlag;
                            this.item.desks = items;
                            this.showSnackbar({
                                text: "Restored " + this.selectedDispatchDesk.name,
                                color: 'success',
                            });
                        }
                        else {
                            throw Error('Unable to restore dispatch desk');
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_4 = _a.sent();
                        this.showSnackbar({
                            text: 'Unable to restore dispatch desk',
                            color: 'error',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.restoreDeskDialog = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // initialize
                this.validationRules = this.carrierService.getValidationRules();
                // default dispatch desk id must start with 4
                this.$validator.localize('en', {
                    custom: { sapId: { regex: this.idValidationMessage } },
                });
                this.readonly = this.carrierService.canEditCarriers === false;
                return [2 /*return*/];
            });
        });
    };
    EditCarrier.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        this.loading = true;
                        if (!this.isExistingCarrier) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.carrierService.getCarrierById(this.$route.params.id)];
                    case 1:
                        _a.item = _b.sent();
                        this.toolbarTitle = this.item.name;
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.restoringPartialSave) {
                            this.item = this.getDataToBeRestored();
                            this.toolbarTitle = "Add New Carrier";
                        }
                        else {
                            this.item = this.carrierService.getDefault();
                            this.toolbarTitle = 'Add New Carrier';
                        }
                        _b.label = 3;
                    case 3:
                        // set the document title
                        document.title = "Fuel Shepherd - Manage Carrier - " + this.item.name;
                        // get reference data
                        return [4 /*yield*/, this.lazyLoadReferenceData()];
                    case 4:
                        // get reference data
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        error_5 = _b.sent();
                        console.error(error_5);
                        this.showSnackbar({ text: 'Unable to load data', color: 'error' });
                        return [3 /*break*/, 7];
                    case 6:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Clear API password if they are using Horizon
     */
    EditCarrier.prototype.onHorizonEnableChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue && oldValue !== newValue) {
            this.$nextTick(function () {
                _this.item.apiPassword = '';
            });
        }
    };
    EditCarrier.prototype.saveDispatchDesk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResult, ableToDelete, sapId, response, items, matchingItems, item, error_6;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, 6, 7]);
                        return [4 /*yield*/, this.$validator.validate('desk.*')];
                    case 1:
                        validationResult = _a.sent();
                        // return if there are validation errors
                        if (validationResult === false) {
                            return [2 /*return*/];
                        }
                        this.savingDispatchDesk = true;
                        if (!(this.selectedDispatchDesk.id !== '' &&
                            this.selectedDispatchDesk.status === this.inactiveFlag)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.carrierService.canDeleteDispatchDesk(this.selectedDispatchDesk)];
                    case 2:
                        ableToDelete = _a.sent();
                        if (ableToDelete === false) {
                            this.$validator.errors.add({
                                scope: 'desk',
                                field: 'status',
                                // tslint:disable-next-line:max-line-length
                                msg: this.selectedDispatchDesk.name + " has associations with a site and material. You must re-assign these to a new dispatch desk first.",
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        // set the parent id
                        this.selectedDispatchDesk.parentId = this.item.id;
                        sapId = this.item.desks.filter(function (desk) { return desk.isDefault && desk.isDefault === true; })[0].id;
                        return [4 /*yield*/, this.carrierService.saveDispatchDesk(this.selectedDispatchDesk, sapId)];
                    case 4:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        items = __spreadArrays(this.item.desks);
                        matchingItems = items.filter(function (desk) { return desk.id === _this.selectedDispatchDesk.id; });
                        if (matchingItems.length === 1) {
                            item = matchingItems[0];
                            item.id = response.data.carrierDispatchDeskId;
                            (item.name = this.selectedDispatchDesk.name),
                                (item.parentId = this.selectedDispatchDesk.parentId);
                            item.email = this.selectedDispatchDesk.email;
                            item.snapshotTime = this.selectedDispatchDesk.snapshotTime;
                            item.status = this.selectedDispatchDesk.status;
                            item.isDefault = this.selectedDispatchDesk.isDefault;
                        }
                        else {
                            this.selectedDispatchDesk.id = response.data.carrierDispatchDeskId;
                            items.push(this.selectedDispatchDesk);
                        }
                        this.item.desks = items;
                        this.showSnackbar({
                            text: "Dispatch desk changes saved",
                            color: 'success',
                        });
                        this.dispatchDeskSideSheet = false;
                        return [3 /*break*/, 7];
                    case 5:
                        error_6 = _a.sent();
                        console.error(error_6);
                        this.showSnackbar({
                            text: 'Unable to save dispatch desk',
                            color: 'error',
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        this.savingDispatchDesk = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationResult, data, response, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.$validator.validate('carrier.*')];
                    case 1:
                        validationResult = _a.sent();
                        // return if there are validation errors
                        if (validationResult === false) {
                            return [2 /*return*/];
                        }
                        this.saving = true;
                        data = __assign({}, this.item);
                        return [4 /*yield*/, this.carrierService.save(data)];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        this.showSnackbar({
                            text: "Successfully " + (this.isExistingCarrier ? 'updated' : 'added') + " '" + this.item.name + "'",
                            color: 'success',
                        });
                        this.$router.push('/config/carrier-management');
                        return [3 /*break*/, 5];
                    case 3:
                        error_7 = _a.sent();
                        console.error(error_7);
                        this.showSnackbar({ text: 'Unable to save Carrier', color: 'error' });
                        return [3 /*break*/, 5];
                    case 4:
                        this.saving = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EditCarrier.prototype, "isExistingCarrier", {
        get: function () {
            return (this.$route.params &&
                this.$route.params.id &&
                this.$route.params.id !== '0');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditCarrier.prototype, "filteredDispatchDesks", {
        get: function () {
            this.loading = true;
            // copy the collection
            var items = __spreadArrays(this.item.desks);
            // filter deleted
            items =
                this.includeDeleted === false
                    ? items.filter(function (item) { return item.status !== 'I'; })
                    : items;
            this.loading = false;
            return items;
        },
        enumerable: false,
        configurable: true
    });
    EditCarrier.prototype.onIncludeDeletedChanged = function (value, oldValue) {
        var _this = this;
        if (value && value !== oldValue) {
            this.$nextTick(function () {
                _this.pagination.page = 1;
            });
        }
    };
    EditCarrier.prototype.lazyLoadReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getsnapshottimes')];
                    case 1:
                        _a.snapShotTimes = _e.sent();
                        _b = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getcarriergroups')];
                    case 2:
                        _b.carrierGroups = _e.sent();
                        _c = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getstatuses')];
                    case 3:
                        _c.statuses = _e.sent();
                        _d = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/gethorizonenabled')];
                    case 4:
                        _d.horizonEnabled = _e.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditCarrier.prototype.getSnapshotTimeFriendly = function (snapshotTime) {
        if (this.options.snapShotTimes.length === 0 || snapshotTime === '') {
            return snapshotTime;
        }
        return this.options.snapShotTimes.filter(function (item) { return item.key === snapshotTime; })[0].value;
    };
    Object.defineProperty(EditCarrier.prototype, "inactiveFlag", {
        get: function () {
            return 'I';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditCarrier.prototype, "activeFlag", {
        get: function () {
            return 'A';
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        lazyInject(TYPES.ReferenceDataService),
        __metadata("design:type", typeof (_a = typeof ReferenceDataService !== "undefined" && ReferenceDataService) === "function" ? _a : Object)
    ], EditCarrier.prototype, "referenceDataService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierService),
        __metadata("design:type", typeof (_b = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _b : Object)
    ], EditCarrier.prototype, "carrierService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierGroupService),
        __metadata("design:type", typeof (_c = typeof CarrierGroupService !== "undefined" && CarrierGroupService) === "function" ? _c : Object)
    ], EditCarrier.prototype, "carrierGroupService", void 0);
    __decorate([
        Watch('item.isHorizonEnabled', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], EditCarrier.prototype, "onHorizonEnableChanged", null);
    __decorate([
        Watch('includeDeleted', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", void 0)
    ], EditCarrier.prototype, "onIncludeDeletedChanged", null);
    EditCarrier = __decorate([
        Component({
            components: {
                'delete-prompt-dialog': DeletePromptDialog,
                'prompt-dialog': PromptDialog,
                'carrier-group-sidesheet': ManageGroupCrudSidesheet,
            },
            $_veeValidate: { validator: 'new' },
        })
    ], EditCarrier);
    return EditCarrier;
}(Mixins(LayoutMixin, SnackbarMixin, PartialSaveMixin)));
export default EditCarrier;
